// extracted by mini-css-extract-plugin
module.exports = {"topsections":"timer_topsections__3FXb7","topsectionshide":"timer_topsectionshide__vZC3Q"};